import { getAccessToken } from '../services/api';
import { Fetch, throwTwirpError } from '../twirp';
import { STSResponse } from './types';

export class DriveServiceImpl {
  private basePath: string;
  protected fetch: Fetch;

  constructor(basePath: string, fetch: Fetch) {
    this.basePath = basePath || '';
    this.fetch = fetch;
  }

  protected url(name: string): string {
    return this.basePath + name;
  }

  public async getAccessKeys(headers: Record<string, string> = {}): Promise<STSResponse> {
    const formData = new URLSearchParams();
    formData.append('Action', 'AssumeRoleWithWebIdentity');
    formData.append('RoleArn', 'drivedrivedrivedrive'); // Dummy value as per H2O Drive guide
    formData.append('RoleSessionName', 'h2o-drive-session');
    formData.append('WebIdentityToken', getAccessToken());
    formData.append('Version', '2011-06-15');

    const body = formData.toString();

    return this.fetch(this.url(''), {
      method: 'POST',
      headers: { ...headers, 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    }).then(async (res) => {
      if (!res.ok) return throwTwirpError(res);

      const xmlText = await res.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlText, 'text/xml');

      const result = xmlDoc.querySelector('AssumeRoleWithWebIdentityResult');
      if (!result) throw new Error('Invalid response format');

      const credentials = result.querySelector('Credentials');
      if (!credentials) throw new Error('No credentials found');

      return {
        subjectFromWebIdentityToken: result.querySelector('SubjectFromWebIdentityToken')?.textContent,
        credentials: {
          accessKeyId: credentials.querySelector('AccessKeyId')?.textContent,
          secretAccessKey: credentials.querySelector('SecretAccessKey')?.textContent,
          sessionToken: credentials.querySelector('SessionToken')?.textContent,
          expiration: credentials.querySelector('Expiration')?.textContent,
        },
      };
    });
  }
}
